export const generateHSL = ({ colors, offset, step, value, }) => {
    step ??= 360 / colors;
    offset ??= 0;
    return `hsl(${Math.round((value % colors) * step + offset)}, 70%, 70%)`;
};
